import { PropertyState } from "../states/ConstructorPageStates/PropertyState";
import {
  CreateFieldRequest,
  FieldDto,
  FieldType,
  SetFieldOrderRequest,
  UpdateFieldRequest,
} from "../../api-client";
import { UniqueId } from "../UniqueId";
import { Status } from "../enums/Status";
import { PropertyType } from "../enums/PropertyType";
import { GamePropertyState } from "../states/GamePageStates/GamePropertyState";

export class PropertiesMapper {
  public static toCreateFieldRequest(
    property: PropertyState
  ): CreateFieldRequest {
    return {
      name: property.name,
      type: this.toFieldType(property.type),
    };
  }

  public static toUpdateFieldRequest(
    property: PropertyState
  ): UpdateFieldRequest {
    return {
      newName: property.name,
      newType: this.toFieldType(property.type),
    };
  }

  public static toPropertyState(
    fieldDto: FieldDto,
    propertyId?: number
  ): PropertyState {
    return {
      id: propertyId ? propertyId : UniqueId.generateUniqueId(),
      apiId: fieldDto.id ? fieldDto.id : null,
      name: fieldDto.name ? fieldDto.name : "",
      status: Status.None,
      type: this.toPropertyType(fieldDto.type!),
    };
  }

  public static toCreateFieldRequests(
    properties: PropertyState[]
  ): CreateFieldRequest[] {
    return properties.map((property) => {
      return {
        name: property.name,
        type: this.toFieldType(property.type),
      };
    });
  }

  public static toUpdateFieldRequests(
    properties: PropertyState[]
  ): UpdateFieldRequest[] {
    return properties.map((property) => {
      return {
        newName: property.name,
        newType: this.toFieldType(property.type),
      };
    });
  }

  public static toPropertyStates(fieldDtos: FieldDto[]): PropertyState[] {
    return fieldDtos.map((fieldDto) => {
      return {
        id: UniqueId.generateUniqueId(),
        apiId: fieldDto.id ? fieldDto.id : null,
        name: fieldDto.name ? fieldDto.name : "",
        status: Status.None,
        type: this.toPropertyType(fieldDto.type!),
      };
    });
  }

  public static toGamePropertyStates(
    fieldDtos: FieldDto[]
  ): GamePropertyState[] {
    return fieldDtos.map((fieldDto) => {
      return {
        id: UniqueId.generateUniqueId(),
        apiId: fieldDto.id!,
        name: fieldDto.name!,
      };
    });
  }

  public static toSetFieldOrderRequest(
    propertyIds: string[]
  ): SetFieldOrderRequest {
    return { fieldIdsInOrder: propertyIds };
  }

  public static toFieldType(propertyType: PropertyType): FieldType {
    switch (propertyType) {
      case PropertyType.String:
        return 0;
      case PropertyType.Integer:
        return 1;
      case PropertyType.Date:
        return 2;
      case PropertyType.Image:
        return 3;
    }
  }

  public static toPropertyType(fieldType: FieldType): PropertyType {
    switch (fieldType) {
      case 0:
        return PropertyType.String;
      case 1:
        return PropertyType.Integer;
      case 2:
        return PropertyType.Date;
      case 3:
        return PropertyType.Image;
      default:
        return PropertyType.Integer;
    }
  }
}
